var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 59 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1101.3,-1665.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,129.303,-116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "matrix(3.24408,0,0,3.24408,962.268,1758.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,7L5,7C3.896,7 3,7.896 3,9L3,18C3,19.104 3.896,20 5,20L19,20C20.104,20 21,19.104 21,18L21,9C21,7.896 20.104,7 19,7ZM9.316,14.316L10.918,15.716C11.223,15.982 11.609,16.114 12,16.114C12.391,16.114 12.777,15.981 13.082,15.716L14.684,14.316L14.647,14.353L18.293,17.999L5.707,17.999L9.353,14.353L9.316,14.316ZM5,17.293L5,10.54L8.602,13.691L5,17.293ZM15.398,13.691L19,10.54L19,17.29L15.398,13.691ZM19,9L19,9.21L12.424,14.964C12.197,15.162 11.803,15.162 11.576,14.964L5,9.21L5,9L19,9Z",
    style: {
      fill: "rgb(247,242,238)",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEmail);
export default __webpack_public_path__ + "static/media/social-email.008ec8f13959e8e3eae49dce19e9bc59.svg";
export { ForwardRef as ReactComponent };